// *******************************************************************************
// Form handling
// *******************************************************************************

const fileCountValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };
    if (input.element.files) {
      const { maxFiles, maxError } = input.element.dataset;
      if (filesToUpload.length > maxFiles) {
        error = {
          valid: false,
          message: maxError,
        };
      }
    }

    return error;
  },
});

const fileSizeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    if (input.element.files) {
      const {
        dataset: { maxSize, sizeError },
      } = input.element;

      for (let i = 0; i < Array.from(filesToUpload).length; i += 1) {
        const { file } = Array.from(filesToUpload)[i];

        if (file.size > maxSize) {
          error = {
            valid: false,
            message: sizeError,
          };
          break;
        }
      }
    }

    return error;
  },
});

const fileTypeValidator = () => ({
  validate: (input) => {
    let error = {
      valid: true,
    };

    if (input.element.files) {
      const {
        dataset: { extension, typeError },
      } = input.element;

      const types = extension.split(',');

      // eslint-disable-next-line no-plusplus
      for (let i = 0; i < Array.from(filesToUpload).length; i++) {
        const { file } = Array.from(filesToUpload)[i];
        const fileType = `.${file.name.split('.').pop()}`;

        if (!types.includes(fileType)) {
          error = {
            valid: false,
            message: typeError,
          };
          break;
        }
      }
    }

    return error;
  },
});

const handleForm = (form, formAction, id) => {
  const formParent = form.closest('[data-parent]');
  const formAlertError = formParent.querySelector('.form-component__alert-error');

  const fv = FormValidation.formValidation(form, {
    locale: 'sl_SI',
    localization: FormValidation.locales.sl_SI,
    fields: {},
    plugins: {
      message: new FormValidation.plugins.Message({
        container: (field, element) =>
          element.closest('.mod-input,.checkbox,.dropdown,.upload-box__main,.radio-button'),
      }),
      declarative: new FormValidation.plugins.Declarative({
        html5Input: true,
      }),
      trigger: new FormValidation.plugins.Trigger({
        event: 'submit',
      }),
      excluded: new FormValidation.plugins.Excluded({
        excluded(field, element) {
          const parentDiv = element.closest('.form-component__row');
          return parentDiv && parentDiv.classList.contains('hide');
        },
      }),
      submitButton: new FormValidation.plugins.SubmitButton(),
    },
  })
    .registerValidator('checkMaxFiles', fileCountValidator)
    .registerValidator('checkFilesSize', fileSizeValidator)
    .registerValidator('checkFilesType', fileTypeValidator)
    .on('core.element.validated', (e) => {
      if (e.element.hasAttribute('required')) {
        const value = fv.getElementValue(e.field, e.element);
        const container = FormValidation.utils.closest(
          e.element,
          '.mod-input, .checkbox, .dropdown, .upload-box__main, .radio-button',
        );
        FormValidation.utils.classSet(container, {
          'is-validation-failed': value === '' || !e.valid,
        });
      }
    })
    .on('core.form.valid', () => {
      grecaptcha.ready(async () => {
        formParent.classList.add('show-loader');
        try {
          const files = {};
          Array.from(filesToUpload).forEach((file, index) => {
            files[`files_${index + 1}`] = file.file;
          });

          let requiredInputs = '';
          form.querySelectorAll('.form-component__inner input, .form-component__inner textarea').forEach((input) => {
            if (input.type !== 'hidden' && input.hasAttribute('required')) {
              requiredInputs += `${input.name}|`;
            }
          });
          requiredInputs = requiredInputs.slice(0, -1);

          const response = await onFormSubmit({
            formData: {
              ...getFormValue(form, fv),
              ...files,
              id: localData.id,
              k: form.querySelector('[data-k]').value,
              lang: localData.lang,
              jobId: form.querySelector('[data-job-id]').value,
              requiredInputs,
            },
            recaptchaKey: form.querySelector('[data-sitekey]').getAttribute('data-sitekey'),
            recaptchaAction: formAction,
          });

          sendToDataLayer(id);

          formParent.classList.remove('show-loader');
          formParent.classList.add('show-thankyou');
          if (formParent.closest('.form-modal')) {
            const formModalEle = formParent.closest('.form-modal');
            formModalEle.classList.add('show-thankyou');
          }
          if (response.data.data.cookie_to_set) {
            Cookies.set(response.data.data.cookie_to_set, true, { expires: 365 });
          }
        } catch (error) {
          console.error(error);
          formParent.classList.remove('show-loader');
          formParent.classList.add('show-error');
          formAlertError.classList.remove('hide');
          formAlertError.innerHTML = error.response.data.data.msg;
        }
      });
    });
};

const sendToDataLayer = (id) => {
  const idToLabel = {
    'contact-form': 'Contact Form',
    'subscribe-form': 'Newsletter Form',
    'lets-meet-form': 'Lets Meet Form',
    'application-form': 'Job Application Form',
    'scroll-banner-contact-form': 'Contact Form',
    'on-scroll-banner-form': 'Newsletter Form',
    'blog-on-scroll-banner-form': 'Newsletter Form',
    'event-on-scroll-banner-form': 'Lets Meet Form',
  };

  // Example usage:
  const label = idToLabel[id] || '';

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'generate_lead',
    label,
    form_id: id || '',
  });
};

document.addEventListener('DOMContentLoaded', () => {
  [
    'contact-form',
    'subscribe-form',
    'lets-meet-form',
    'application-form',
    'scroll-banner-contact-form',
    'on-scroll-banner-form',
    'blog-on-scroll-banner-form',
    'event-on-scroll-banner-form',
  ].forEach((id) => {
    const form = document.querySelector(`#${id}`);
    if (form !== null) {
      const formAction = form.querySelector('[data-action]').value;
      handleForm(form, formAction, id);
    }
  });
});

// Check if all checkboxes in group have same name
document.querySelectorAll('.form-component__row').forEach((formRow) => {
  const checkboxes = formRow.querySelectorAll('input[type="checkbox"]');

  if (checkboxes.length > 1) {
    const uniqueNames = new Set([...checkboxes].map((checkbox) => checkbox.name));
    const isCheckboxGroup = uniqueNames.size === 1;

    formRow.classList.toggle('checkbox-group', isCheckboxGroup);

    // Check if failed
    const observer = new MutationObserver(() => {
      const checkboxParents = formRow.querySelectorAll('.checkbox');
      const hasFailedCheckbox = [...checkboxParents].some((checkboxParent) =>
        checkboxParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedCheckbox);
    });
    checkboxes.forEach((checkbox) =>
      observer.observe(checkbox.closest('.checkbox'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div
    if (formRow.classList.contains('checkbox-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.appendChild(groupErrorMessage);
      }
    }
  }
});

// Check if all radioButtons in group have same name
document.querySelectorAll('.radio-button-group').forEach((formRow) => {
  const radioButtons = formRow.querySelectorAll('input[type="radio"]');
  if (radioButtons.length > 1) {
    // Check if failed
    const observer = new MutationObserver(() => {
      const radioParents = formRow.querySelectorAll('.radio-button');
      const hasFailedRadio = [...radioParents].some((radioParent) =>
        radioParent.classList.contains('is-validation-failed'),
      );
      formRow.classList.toggle('failed', hasFailedRadio);
    });

    radioButtons.forEach((radio) =>
      observer.observe(radio.closest('.radio-button'), { attributes: true, attributeFilter: ['class'] }),
    );

    // Get the first error message and create a new div
    if (formRow.classList.contains('radio-button-group')) {
      const errorMessage = formRow.querySelector('[data-fv-not-empty___message]');
      if (errorMessage) {
        const groupErrorMessage = document.createElement('div');
        groupErrorMessage.classList.add('fv-plugins-message-container', 'group-error');
        groupErrorMessage.innerHTML = errorMessage.getAttribute('data-fv-not-empty___message');

        formRow.appendChild(groupErrorMessage);
      }
    }
  }
});

// Show/hide interest multiple selection
const meetingRow = document.querySelector('.form-component__row--meeting');
const meetingInputs = document.querySelectorAll('.form-component__row--meeting input');
const interestSelection = document.querySelector('.form-component__row--interest');
const interestSelectionContainer = document.querySelector(
  '.form-component__row--interest .multiple-selection__selections',
);

const clearInterest = (selectedInterest) => {
  selectedInterest.forEach((parent) => {
    const selectedInterestInputs = parent.querySelectorAll('input');

    selectedInterestInputs.forEach((input) => {
      if (input.checked || input.indeterminate) {
        input.checked = false;
        input.indeterminate = false;
        const inputId = input.getAttribute('id');
        const selectedTag = document.querySelector(`[data-input=${inputId}]`);
        selectedTag?.remove();
        const selectedTags = document.querySelectorAll('[data-input]');
        interestSelectionContainer.classList.toggle('hide', !selectedTags.length);
      }
    });
  });
};

const toggleInterest = (interests, toggle) => {
  interests.forEach((item) => {
    item.classList.toggle('hide', !toggle);
    item.classList.toggle('is-active', toggle);
  });
};

meetingInputs.forEach((input) => {
  input.addEventListener('change', (el) => {
    const selectedInputs = meetingRow.querySelectorAll('input:checked');
    if (interestSelection) {
      interestSelection.classList.toggle('hide', !selectedInputs.length);
    }
    const selectedId = el.target.getAttribute('id');
    const selectedInterest = document.querySelectorAll(`[data-main-parent="${selectedId}"]`);

    if (el.target.checked) {
      toggleInterest(selectedInterest, true);
    } else {
      clearInterest(selectedInterest);
      toggleInterest(selectedInterest, false);
    }
  });
});
